import { PropsWithChildren } from "react";
import { Dialog } from "@headlessui/react";
import CloseIcon from "components/icons-svg/CloseIcon";
import { VariantProps, cva } from "utils/cva";
const modalWrapper = cva("flex h-full justify-center", {
  variants: {
    intent: {
      modal: ["items-center"],
      modalDrawer: ["items-end sxm:items-center"]
    },
    size: {
      extraLarge2: [],
      extraLarge: [],
      large: ["px-2 py-6 min-h-full h-[inherit!important]"],
      mediumToFull: ["sxm:py-4"],
      fullScreen: [],
      medium: ["px-2"],
      mediumToSmall: [],
      small: [],
      extraSmall: []
    }
  },
  compoundVariants: [{
    intent: ["modalDrawer"],
    size: ["medium"],
    className: "pl-0 pr-0"
  }],
  defaultVariants: {
    intent: "modal",
    size: "mediumToFull"
  }
});
const modalBody = cva("flex flex-col bg-offWhite shadow-xl transition-all", {
  variants: {
    intent: {
      modal: [],
      modalDrawer: ["h-[80vh] sxm:h-auto rounded-[20px_20px_0_0] sxm:rounded-2xl"]
    },
    size: {
      extraLarge2: ["rounded-xl", "max-w-[1000px]", "w-full"],
      extraLarge: ["rounded-xl", "max-w-[925px]", "w-full"],
      large: ["rounded-md", "max-w-[675px]", "w-full"],
      mediumToFull: ["h-[100svh]", "w-full", "min-w-[auto]", "max-w-[650px]", "transform", "text-left", "align-middle", "sxm:h-[calc(100dvh_-_2rem)]", "sxm:rounded-2xl", "md:min-w-[650px]"],
      medium: ["w-full", "min-w-[auto]", "max-w-[650px]", "transform", "text-left", "align-middle", "max-h-[calc(100dvh_-_8rem)]", "rounded-2xl", "md:min-w-[650px]"],
      mediumToSmall: ["rounded-2xl", "max-w-[576px]", "w-full"],
      small: ["rounded-2xl", "max-w-[448px]", "w-full"],
      extraSmall: ["rounded-2xl", "max-w-[384px]", "w-full"],
      fullScreen: ["h-[100svh]", "w-full"]
    }
  },
  defaultVariants: {
    intent: "modal",
    size: "mediumToFull"
  }
});
interface DialogModelProps {
  isOpen: boolean;
  onClose?: () => void;
  className?: string;
  closeOnClickOutSide?: boolean;
  isCloseIcon?: boolean;
  classNameDialog?: string;
  classNameCloseIcon?: string;
  modalOverlayColor?: string;
}
const CVAModal = ({
  isOpen,
  onClose = () => {},
  children,
  intent,
  size,
  className = "",
  closeOnClickOutSide = true,
  isCloseIcon = true,
  classNameDialog = "",
  classNameCloseIcon = "",
  modalOverlayColor = "bg-[rgba(0,0,0,0.48)]"
}: PropsWithChildren<DialogModelProps & VariantProps<typeof modalBody>>) => {
  return <Dialog as='div' className={`relative z-[999] ${classNameDialog}`} onClose={closeOnClickOutSide || !isCloseIcon ? onClose : () => {}} open={isOpen} aria-label='common modal' data-sentry-element="Dialog" data-sentry-component="CVAModal" data-sentry-source-file="CVAModal.tsx">
      <div className={`fixed inset-0 left-0 top-0 h-screen w-screen ${modalOverlayColor}`} aria-hidden='true' />
      <div className='fixed inset-0 overflow-y-auto'>
        <div className={modalWrapper({
        intent,
        size
      })}>
          <Dialog.Panel className={modalBody({
          intent,
          size,
          className
        })} data-sentry-element="Dialog.Panel" data-sentry-source-file="CVAModal.tsx">
            {isCloseIcon && <button type='button' id='close-modal' aria-label='close modal' className='btn btn-ghost absolute right-4 top-4 z-20 h-9 w-9 min-w-[0] rounded-lg px-1 py-1 text-secondary1000 hover:bg-gray-200/50' onClick={onClose}>
                <CloseIcon className={`h-6 w-6 text-inherit ${classNameCloseIcon}`} />
              </button>}
            {children}
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>;
};
export default CVAModal;